import React, { useState } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import {
  Popconfirm,
  message,
  Card,
  Typography,
  Tag,
  Button,
  Space,
  Tooltip,
  Switch,
  Segmented,
  Menu,
  Dropdown,
} from "antd";
import { postReq, deleteApi } from "../api";
import { Link } from "react-router-dom";
import moment from "moment";
import { toastNotification } from "../utils/toasthelper";
import useUserDetails from "../utils/useUserDetails";
const { Title, Text } = Typography;

const CardComponent = ({
  requirementName,
  jobId,
  requirementType,
  maxExperience,
  minExperience,
  jobLocation,
  requirementNiche,
  requirementStatus,
  workType,
  vacancy,
  budget,
  data,
  fetch,
  client,
}) => {
  const [loading, setLoading] = useState(false);
  const firstTwoTechnology = requirementNiche.slice(0, 2);
  const remainingTechnologyCount = requirementNiche.length - 2;
  const remainingTechnology = requirementNiche.slice(
    2,
    requirementNiche.length
  );
  const { userRole, permissions } = useUserDetails();

  const onChange = async () => {
    setLoading(true);
    let response;
    response =
      userRole == "company"
        ? await postReq("company/requirement/update-status", {
            requirementId: data._id,
            clientId: data.clientId,
            requirementStatus:
              data.requirementStatus == "open" ? "close" : "open",
          })
        : permissions.includes("update_requirement_status")
        ? await postReq("common/requirement/update-status", {
            requirementId: data._id,
            clientId: data.clientId,
            requirementStatus:
              data.requirementStatus == "open" ? "close" : "open",
          })
        : { status: 0 };
    if (response.status == 1) {
      fetch();
    }
    setLoading(false);
  };

  const deleteRequirementAPI = async () => {
    try {
      const res = await deleteApi(
        `company/requirement/${data._id}`,
        {},
        "DELETE"
      );
      if (res.data.status === 1) {
        toastNotification("success", "Requirement deleted successfully");
        fetch();
      } else {
        toastNotification(
          "error",
          res.message || "Unable to delete requirement"
        );
      }
    } catch (err) {
      console.error(err);
      message.error("Server error");
    }
  };
  const menu = (
    <Menu
      onClick={async ({ key }) => {
        let response;
        response =
          userRole == "company"
            ? await postReq("company/requirement/update-status", {
                requirementId: data._id,
                clientId: data.clientId,
                requirementStatus: key,
                // data.requirementStatus == "open" ? "close" : "open",
              })
            : permissions.includes("update_requirement_status")
            ? await postReq("common/requirement/update-status", {
                requirementId: data._id,
                clientId: data.clientId,
                requirementStatus: key,
                // data.requirementStatus == "open" ? "close" : "open",
              })
            : { status: 0 };
        if (response.status == 1) {
          fetch();
        }
        setLoading(false);
      }}
      items={[
        { key: "open", label: "OPEN" },
        { key: "on-hold", label: "HOLD" },
        { key: "close", label: "CLOSE" },
      ]}
    />
  );

  return (
    <Card
      className="cardComponent"
      style={{
        height: "100%",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "20px",
      }}
      title={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: `${
              data?.workType == "remote" ? "#3699FF" : "#13487D"
            }  `, //
            color: "black",
            padding: "18px 12px",
            borderRadius: "20px 20px 0px 0px",
            margin: "0px , -14px",
          }}
        >
          <div>
            <Title
              level={4}
              style={{
                marginBottom: 0,
                fontSize: "16px",
                fontWeight: "500",
                color: "white",
              }}
            >
              {requirementName}
              {" - "}
              {jobId}
            </Title>
          </div>

          <div>
            <Space direction="middle">
              {permissions.includes("delete_requirements") && (
                <Popconfirm
                  title="Delete Requirement"
                  description="Are you sure you want to delete this requirement?"
                  okText="Yes"
                  cancelText="No"
                  onConfirm={deleteRequirementAPI}
                >
                  <DeleteOutlined
                    style={{
                      fontSize: 18,
                      color: "white",
                      cursor: "pointer",
                      marginRight: 8,
                    }}
                  />
                </Popconfirm>
              )}
              {/* <Switch
                checkedChildren="OPEN"
                unCheckedChildren="CLOSE"
                checked={data.requirementStatus == "open" ? true : false}
                onChange={onChange}
                loading={loading}
                disabled={!permissions.includes("update_requirement_status")}
              /> */}
              {/* <Segmented
                size="small"
                options={[
                  { label: "OPEN", value: "open" },
                  { label: "HOLD", value: "on-hold" },
                  { label: "CLOSE", value: "close" },
                ]}
                value={data.requirementStatus}
                disabled={!permissions.includes("update_requirement_status")}
                onChange={async (value) => {
                  setLoading(true);

                  const response =
                    userRole === "company"
                      ? await postReq("company/requirement/update-status", {
                          requirementId: data._id,
                          clientId: data.clientId,
                          requirementStatus: value,
                        })
                      : permissions.includes("update_requirement_status")
                      ? await postReq("common/requirement/update-status", {
                          requirementId: data._id,
                          clientId: data.clientId,
                          requirementStatus: value,
                        })
                      : { status: 0 };

                  if (response.status === 1) fetch();
                  setLoading(false);
                }}
              /> */}
              <Dropdown overlay={menu} trigger={["click"]}>
                <Tag
                  // color={
                  //   data.requirementStatus === "open"
                  //     ? "green"
                  //     : data.requirementStatus === "on-hold"
                  //     ? "gold"
                  //     : "red"
                  // }
                  style={{ cursor: "pointer", borderRadius: "8px" }}
                >
                  {data.requirementStatus.toUpperCase()}
                </Tag>
              </Dropdown>
            </Space>
          </div>
        </div>
      }
    >
      <Link
        to={{
          pathname: "/company/requirement_description",
          state: {
            data: data,
          },
        }}
      >
        <div style={{ marginTop: 1 }}>
          {/* <Tag
          color="#E7F1FC"
          style={{
            border: "2px solid #C1D6EE",
            borderRadius: "16px",
            padding: "2px 10px",
            fontSize: "12px",
          }}
        >
          <span style={{ color: "#13487D", fontWeight: "600" }}>
            Job ID {jobId}
          </span>
        </Tag> */}
          <div style={{ marginTop: 6, fontSize: "12px" }}>
            <Text>
              <strong>Name :</strong>
              <span style={{ color: "#666666" }}>
                {" "}
                {client.clientCompanyName}
              </span>
            </Text>
          </div>
          <div style={{ marginTop: 12, fontSize: "12px" }}>
            <Text>
              <strong>Vacancy :</strong>
              <span style={{ color: "#666666" }}> {vacancy}</span>
            </Text>
          </div>
          <div style={{ marginTop: 12, fontSize: "12px" }}>
            <Text>
              <strong>Experience :</strong>
              <span
                style={{ color: "#666666" }}
              >{` ${minExperience} to ${maxExperience} years`}</span>
            </Text>
          </div>
          <div style={{ marginTop: 12, fontSize: "12px" }}>
            <Text>
              <strong>Job Type :</strong>
              <span style={{ color: "#666666" }}> {requirementType}</span>
            </Text>
          </div>

          {/* Experience */}

          {/* Location */}
          <div style={{ marginTop: 12, fontSize: "12px" }}>
            <Text>
              <strong>Location :</strong>

              <span style={{ color: "#666666" }}>
                {jobLocation} | {workType}
              </span>
            </Text>
          </div>

          <div style={{ marginTop: 12, fontSize: "12px" }}>
            <Text>
              <strong>Budget :</strong>
              <span style={{ color: "#666666" }}>
                {" "}
                {budget} <span style={{ fontSize: "10px" }}>+GST.</span>
              </span>
            </Text>
          </div>
          <div style={{ marginTop: 12, fontSize: "12px" }}>
            <Text>
              <strong>Date :</strong>
              <span style={{ color: "#666666" }}>
                {moment(data.createdAt).format("DD/MM/YYYY")}
              </span>
            </Text>
          </div>

          {/* Skills */}
          <div
            style={{
              marginTop: 12,
              fontSize: 12,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <Text
              style={{
                whiteSpace: "nowrap",
                marginRight: "5px",
              }}
            >
              <strong>Skill:</strong>
            </Text>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              <div
                // size={"small"}
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "0px",
                }}
              >
                {firstTwoTechnology?.map((data) => (
                  <Tag
                    style={{
                      borderRadius: "20px",
                      color: "#13487D",
                      fontWeight: "600",
                      border: "2px solid #C1D6EE",
                    }}
                  >
                    {data?.value}
                  </Tag>
                ))}
                {remainingTechnologyCount > 0 && (
                  <Tooltip
                    placement="top"
                    title={
                      <div
                        style={{
                          gap: "4px",
                          maxWidth: "200px",
                          wordWrap: "break-word",
                        }}
                      >
                        {remainingTechnology.map((data, i) => (
                          <span key={i} style={{ whiteSpace: "nowrap" }}>
                            <p style={{ fontSize: "12px", margin: 0 }}>
                              {data.value}
                            </p>
                          </span>
                        ))}
                      </div>
                    }
                  >
                    <Button
                      type="primary"
                      shape="circle"
                      style={{
                        backgroundColor: "#1A90FF",
                        border: "none",
                        borderRadius: "16px",
                        width: "18px",
                        height: "22px",
                        fontWeight: "bold",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0px 4px 6px rgb(26,144,255,0.3)",
                      }}
                    >
                      +{remainingTechnologyCount}
                    </Button>
                  </Tooltip>
                )}
              </div>
            </div>
          </div>
        </div>
      </Link>
    </Card>
  );
};

export default CardComponent;
